import GeoUtils from '@front/volcanion/utils/geo'
import { I18n } from '@front/volcanion'

class Callbacks {
  static recordToFormHandler() {
    return function recordToForm(record) {
      return {
        name: record?.name_trkey?.fr,
        type: record?.type,
        poi_client_id: record?.poi_client_id,
        active: record?.active,
        planned_fee: record?.planned_fee,
        required_additional_info: record?.required_additional_info,
        name_trkey: record?.name_trkey,
        meeting_point_trkey: record?.meeting_point_trkey,
        driver_instruction_trkey: record?.driver_instruction_trkey,
        driver_instruction: record?.driver_instruction_trkey?.fr,
        meeting_point_coordinates: record?.meeting_point_coordinates,
        coordinates: record?.coordinates,
        address: {
          formatted_address: GeoUtils.mergeAddress(record)
        },
        city_polygon: record?.city_polygon
      }
    }
  }

  static getEmptyFormHandler(commercialpackage_id) {
    return function getEmptyFormValues() {
      return {
        active: false
      }
    }
  }

  static recordToStateHandler() {
    return function recordToState(record) {
      return {
        title: _.get(record, 'name_trkey.fr'),
      }
    }
  }

  static formToRecordHandler() {
    return function formToRecord(values, extra, meta, state) {
      const current_lat = _.find(meta, ['field', 'meeting_point_coordinates.lat'])?.initial
      const current_lng = _.find(meta, ['field', 'meeting_point_coordinates.lng'])?.initial

      return _.merge({}, {
        name: values?.name,
        type: values?.type,
        poi_client_id: values?.poi_client_id,
        active: values?.active,
        planned_fee: values?.planned_fee,
        required_additional_info: values?.required_additional_info,
        name_trkey: values?.name_trkey,
        meeting_point_trkey: values?.meeting_point_trkey,
        driver_instruction_trkey: values?.driver_instruction_trkey,
        driver_instruction: values?.driver_instruction,
        address: values?.address,
        city_polygon: values?.city_polygon
      },
        (!!values?.meeting_point_coordinates?.lat || !!values?.meeting_point_coordinates?.lng) ? {
          meeting_point_coordinates: {
            lat: _.toNumber(values?.meeting_point_coordinates?.lat || current_lat),
            lng: _.toNumber(values?.meeting_point_coordinates?.lng || current_lng),
          }
        } : {}
      )
    }
  }

  static getFailedNotificationHandler() {
    return function getFailedNotification(err, data, extra, meta, state) {
      const code = err.getCode()
      if (code === 'UNPRECISE_ADDRESS') {
        return [I18n.t('error.address.unprecise'), { variant: 'error' }]
      }
    }
  }
}

export default Callbacks
